"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingUpdateActivity = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const getPostBookingExceptionString_1 = require("../hooks/getPostBookingExceptionString");
const KeyValueDisplay_1 = require("./KeyValueDisplay");
const postBookingChangeFieldNamesTranslations = {
    total: 'activity-feed-booking-update-activity_total',
    mainCarrier: 'activity-feed-booking-update-activity_mainCarrier',
    contractNumber: 'activity-feed-booking-update-activity_contractNumber',
    transitTime: 'activity-feed-booking-update-activity_transitTime',
    etd: 'activity-feed-booking-update-activity_etd',
    eta: 'activity-feed-booking-update-activity_eta',
    vesselName: 'activity-feed-booking-update-activity_VesselName',
    lclCargo: 'activity-feed-booking-update-activity_lclCargo',
    stackable: 'activity-feed-booking-update-activity_stackable',
    insurance: 'activity-feed-booking-update-activity_insurance',
    hsCodesCount: 'activity-feed-booking-update-activity_hsCodesCount',
    customsType: 'activity-feed-booking-update-activity_customsType',
    destinationCustomsType: 'activity-feed-booking-update-activity_destinationCustomsType',
    originCustomsType: 'activity-feed-booking-update-activity_originCustomsType',
    customsIssuance: 'activity-feed-booking-update-activity_customsIssuance',
    customsBondType: 'activity-feed-booking-update-activity_customsBondType',
    vgm: 'activity-feed-booking-update-activity_vgm',
    containers: 'activity-feed-booking-update-activity_containers',
    customerCharged: 'activity-feed-booking-update-customer_charged',
    mode: 'activity-feed-booking-update-mode',
    destinationDepot: 'activity-feed-booking-update-destination_depot',
    terminal: 'activity-feed-booking-update-terminal',
    roundTrip: 'activity-feed-booking-update-round_trip',
    repositioningPrice: 'activity-feed-booking-update-repositioning_price',
    dropOffPrice: 'activity-feed-booking-update-drop_off_price',
    carrier: 'activity-feed-booking-update-carrier',
    carriagePrice: 'activity-feed-booking-update-carriage_price',
    pickupAddress: 'activity-feed-booking-update-pickup_address',
    originDepot: 'activity-feed-booking-update-origin_depot',
    serviceLevel: 'activity-feed-booking-update-service_level',
    airline: 'activity-feed-booking-update-airline',
    flightNumber: 'activity-feed-booking-update-flight_number',
    p2pTransitTime: 'activity-feed-booking-update-p2p_transit_time',
    totalTransitTime: 'activity-feed-booking-update-total_transit_time',
    lineItem: 'activity-feed-booking-update-line_item',
    quantity: 'activity-feed-booking-update-quantity',
    unitPrice: 'activity-feed-booking-update-unit_price',
    postCarrier: 'activity-feed-booking-update-post_carrier',
    onCarriagePrice: 'activity-feed-booking-update-on_carriage_price',
};
const BookingUpdateActivity = ({ activity: { reason, exception, customerCharged, changedFields }, }) => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const exceptionFields = (0, getPostBookingExceptionString_1.usePostBookingExceptionString)(exception);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [reason && (0, jsx_runtime_1.jsx)(KeyValueDisplay_1.KeyValueDisplay, { label: "Change reason shown to customer", value: reason }), exceptionFields.map(([key, value]) => key && (0, jsx_runtime_1.jsx)(KeyValueDisplay_1.KeyValueDisplay, { label: key, value: value || '' }, key)), (0, jsx_runtime_1.jsx)(KeyValueDisplay_1.KeyValueDisplay, { label: "Customer Charged", value: customerCharged ? 'Yes' : 'No' }), changedFields.map((changedField) => ((0, jsx_runtime_1.jsx)(KeyValueDisplay_1.KeyValueDisplay, { label: translate(postBookingChangeFieldNamesTranslations[changedField.field]) || changedField.field, value: changedField.newValue }, changedField.field)))] }));
};
exports.BookingUpdateActivity = BookingUpdateActivity;
//# sourceMappingURL=BookingUpdateActivity.js.map